<template>
  <section v-if="active" class="app-modal__section">
    <header class="app-modal__section-head">
      <h4>Contacto</h4>
      <p>Canales para comunicación y notificaciones.</p>
    </header>

    <div class="app-modal__grid two-columns">
      <label class="app-modal-field">
        <span>Email</span>
        <input
          v-model.trim="form.email"
          type="email"
          class="form-control"
          placeholder="correo@empresa.com"
          autocomplete="off"
          @blur="v$.form.email.$touch()"
          :class="{ 'is-invalid': v$.form.email.$error }"
        />
        <div class="invalid-feedback d-block" v-if="v$.form.email.$error">
          <span v-if="v$.form.email.$errors.length">
            {{ v$.form.email.$errors[0].$message }}
          </span>
        </div>
      </label>

      <label class="app-modal-field">
        <span>Celular</span>
        <input v-model.trim="form.cell_phone" type="text" class="form-control" placeholder="(00) 0000-0000" autocomplete="off" />
      </label>

      <label class="app-modal-field">
        <span>Teléfono oficina</span>
        <input v-model.trim="form.office_phone" type="text" class="form-control" placeholder="(00) 0000-0000" autocomplete="off" />
      </label>

      <label class="app-modal-field">
        <span>Extensión</span>
        <input v-model.trim="form.office_phone_ext" type="text" class="form-control" placeholder="101" autocomplete="off" />
      </label>

      <label class="app-modal-field">
        <span>Teléfono casa</span>
        <input v-model.trim="form.home_phone" type="text" class="form-control" placeholder="(00) 0000-0000" autocomplete="off" />
      </label>

      <label class="app-modal-field">
        <span>Teléfono adicional</span>
        <input v-model.trim="form.fax" type="text" class="form-control" placeholder="(00) 0000-0000" autocomplete="off" />
      </label>
    </div>
  </section>
</template>

<script>
export default {
  name: 'PersonSectionContact',
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    form: {
      type: Object,
      required: true,
    },
    v$: {
      type: Object,
      required: true,
    },
  },
};
</script>
